export enum ColorList {
  PRIMARY = '#152e64',
  SUCCESS = '#28a745',
  DANGER = '#dc3545',
  WARNING = '#ffc107',
  SECONDARY = '#e8edfb',
  ALTERNATIVE = '#1f76ff',
  TERTIARY = '#f6f6ff',
  FLASH = '#ffd0bc',
  BLUE_BRIGHT = '#2774ff',
  GREY = '#d4d4d4',
  CORALTWO = '#ff4343',
  DANGER_ALERT_BOTTOM = '#F86464',
  TEXT = '#414141',
  PAYMENT = '#f69063',
  TEXT_TWO = '#363655',
  DISABLED = '#d8d8df',
  TEXT_DISABLED = '#8e8e93',
  TANGERINE = '#f88f00',
  TANGERINE10 = '#fcf2e4',
  VERY_LIGHT_PINK = '#ffe0e0',
  LIGHT_NAVY = '#162d64',
  VERY_LIGHT_BLUE = '#e8efff',
}
